import { Grid, Tab, Tabs } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import FundamentalDetails from "./FundamentalDetails";
import CompanyCard from "./CompanyCard";
import PricesPage from "./PricesPage";
import HistoricalPrices from "./HistoricalPrices";
import CorporateAction from "./CorporateActions";

const CompanyUpdate = () => {
  const { id } = useParams();

  const [companyTabs, setCompanyTabs] = useState(0);

  const {
    data: companyDetails,
    isFetching: companyFetching,
    refetch,
  } = useQuery({
    queryKey: [QueryKeys.COMPANY_LIST, id],
    queryFn: async () => axiosInstance.get(`/admin-instrument/${id}/details/`),
    onError: (error) => {},
  });

  return (
    <DashboardLayout
      title="Company Details"
      breadcrumbs={[
        {
          name: "Company Master",
          path: "/app/company-master",
        },
        {
          name: "Details",
          path: "",
        },
      ]}
    >
      <Grid container>
        <Grid item xs={12} mb={1}>
          <CompanyCard companyDetails={companyDetails?.data} />
        </Grid>
        <Grid item xs={12} mb={1}>
          <Tabs
            variant="fullWidth"
            onChange={(e, val) => {
              setCompanyTabs(val);
            }}
            value={companyTabs}
          >
            <Tab label="Fundamental Details" />
            <Tab label="NSE, BSE And ISIN" />
            <Tab label="Historical Prices" />
            <Tab label="Corporate Actions" />
          </Tabs>
        </Grid>

        <Grid item xs={12}>
          {!companyFetching && companyTabs === 0 && (
            <FundamentalDetails
              companyDetails={companyDetails?.data?.data}
              refetch={refetch}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          {companyTabs === 1 && <PricesPage />}
        </Grid>
        <Grid item xs={12}>
          {companyTabs === 2 && <HistoricalPrices />}
        </Grid>
        <Grid item xs={12}>
          {companyTabs === 3 && <CorporateAction />}
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default CompanyUpdate;
